export default __webpack_public_path__ + "static/media/google-play-badge.5b119d76.svg";